module.exports = __webpack_public_path__ + "img/ios-woman.05033c78.svg";